<template>
  <panel-main-template>
    <template v-slot:page-title>
      Расчет зарплат
    </template>
    <template v-slot:page-info>
      Обращаем ваше внимание, что такие параметры, как "Выручка сотрудника",
      "Количество записей", "Общая выручка" считаются на основе записей в статусе
      "Выполнено", поэтому, если вы не следите за статусами, то формулы с этими значениями
      будут показывать неверный результат. Вы можете воспользоваться функцией "Завершить старые записи",
      которая находится в разделе "Журнал записей" в кнопке с изображением волшебной палочки.<br>
      Вы можете запросить новые формулы расчета через раздел "Поддержка", если
      таковые отсутствуют
    </template>
    <template v-slot:page-content>
      <div class="calc-salary--container">

        <div v-if="requestCount > 0 && staff.length === 0" class="text-orange">
          Похоже, что у вас еще не создано ни одного сотрудника
        </div>

        <div v-if="requestCount > 0 && staff.length > 0" class="calc-salary--formulas width-100p shadow-card">
          <div class="text-bold">Сотрудники и формулы для расчета з/п</div>
          <div class="mrg-t-15">
            <div class="calc-salary--staffs">
              <div
                v-for="item in staff"
                :key="item.id"
                class="calc-salary--staff"
              >
                <div class="shadow-card">
                  <div class="calc-salary--flex">
                    <div class="avatar">
                      <img :src="returnUpdatedImgLink(item.avatar)">
                    </div>
                    <div class="info">
                      <div class="name">{{item.name}}</div>
                      <div class="mrg-t-15 formula">
                        <div v-if="!item.salary_exists" class="no-formula">
                          <div class="text-orange">
                            Формула не выбрана
                          </div>
                          <div class="mrg-t-15">
                            <div @click="showAddFormulaPopup(item.id, item.name)" class="btn btn-sm btn-outline-info">
                              Выбрать формулу
                            </div>
                          </div>
                        </div>
                        <div v-if="item.salary_exists" class="yes-formula">
                          <div class="text-bold">{{item.salary_formula}}</div>
                          <div class="mrg-t-15">
                            <div @click="showAddFormulaPopup(item.id, item.name)" class="btn btn-sm btn-info">
                              Изменить
                            </div>
                            <div @click="showDeleteFormulaPopup(item.id, item.name)" class="btn btn-sm btn-danger">
                              Удалить
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
            v-if="requestCount > 0 && staff.length > 0"
            class="calc-salary--statistic width-100p mrg-t-20 shadow-card">
          <div class="text-bold">Таблица расчета</div>
          <div class="mrg-t-15">
            <div class="date-interval">
              <div><b>Выберите период</b></div>
              <div class="row mrg-t-10">
                <div class="input-block">
                  <label>Дата от</label>
                  <date-picker v-model="periodDateFrom"></date-picker>
                </div>
                <div class="input-block">
                  <label>Дата до</label>
                  <date-picker v-model="periodDateTo"></date-picker>
                </div>
              </div>
              <div class="hint">
                Максимальный период - 6 месяцев
              </div>
            </div>
          </div>
          <div class="stat mrg-t-25">
            <div class="stat-container">
              <div class="shadow-card item mrg-t-10" v-for="item in statistics" :key="item.id">
                <div class="text-bold">{{item.name}}</div>
                <div class="mrg-t-15 result">Результат: <span class="text-bold">{{item.salary.value}}</span></div>
                <div class="mrg-t-15">
                  <div
                      class="text-small"
                      v-for="variable in item.salary.variables"
                      :key="variable.variable"
                  >
                    {{variable.variable_rus}} = {{variable.value}}
                  </div>
                </div>
                <div class="mrg-t-10 text-small">Рассчитано по формуле: {{item.salary.formula}}</div>
              </div>
            </div>
          </div>
        </div>

        <popup
          :closeButton="addFormulaPopup.closeButton"
          :show="addFormulaPopup.show"
          @closePopup="closeAddFormulaPopup"
        >
          <div slot="header">Добавление формулы для {{addFormulaStaffName}}</div>
          <div slot="body">
            <div
                v-for="item in formulas"
                :key="item.id"
                class="formulas--item mrg-t-25"
            >
              <div class="formula text-bold">{{item.rus_formula}}</div>
              <div class="descr text-hint" v-html="item.description"></div>
              <div class="variables">
                <div
                    v-for="(variable, index) in item.variables"
                    :key="index"
                    class="variable mrg-t-10"
                >
                  {{variable.variable_rus_name}} =
                  <input class="inline-input-middle" type="text" v-model="variable.variable_value">
                </div>
              </div>
              <div class="action text-right">
                <div @click="addFormula(item)" class="btn btn-sm btn-info">Выбрать</div>
              </div>
            </div>
          </div>
        </popup>

        <popup
            :closeButton="deleteFormulaPopup.closeButton"
            :actionButton="deleteFormulaPopup.actionButton"
            :actionClass="deleteFormulaPopup.actionClass"
            :show="deleteFormulaPopup.show"
            @closePopup="closeDeleteFormulaPopup"
            @actionPopup="deleteFormulaSubmit"
        >
          <div slot="header">Удаление формулы для {{addFormulaStaffName}}</div>
          <div slot="body">
            Формула будет удалена для данного сотрудника. Сотрудник не будет участвовать в
            подсчете заработной платы
          </div>
        </popup>

      </div>
    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src
import PanelMainTemplate from "../../components/panel/MainTemplate";
import Popup from "../../components/Popup";
import Validator from "../../components/libraries/Validator";
import DatePicker from "../../components/DatePicker";
import salaryRepository from "../../repositories/salary";

const validator = new Validator();

export default {
  name: "CalcSalary",
  components: {
    DatePicker,
    Popup,
    PanelMainTemplate,
  },
  data() {
    return {
      periodDateFrom: '',
      periodDateTo: '',
      requestCount: 0,
      formulas: [],
      staff: [],
      addFormulaStaffId: 0,
      addFormulaStaffName: '',
      addFormulaPopup: {
        show: false,
        closeButton: "Закрыть",
      },
      deleteFormulaPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      statistics: []
    };
  },
  watch: {
    periodDateFrom: function(val){
      if(val !== '' && this.isSelectedPeriod){
        this.getStatistic();
      }
    },
    periodDateTo: function(val){
      if(val !== '' && this.isSelectedPeriod){
        this.getStatistic();
      }
    }
  },
  computed: {
    isSelectedPeriod(){
      let result = false;
      if(this.periodDateFrom != '' && this.periodDateTo != ''){
        result = true;
      }
      return result;
    }
  },
  methods: {
    deleteFormulaSubmit(){
      salaryRepository.deleteFormula({ staff_id: this.addFormulaStaffId }).then(resp => {
        if(resp.data.result === 'ok'){
          this.getStaff();
          this.closeDeleteFormulaPopup();
        }
      }).catch(err => {
        this.getFormulas();
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    closeDeleteFormulaPopup(){
      this.deleteFormulaPopup.show = false;
    },
    showDeleteFormulaPopup(staffId, staffName){
      this.addFormulaStaffName = staffName;
      this.addFormulaStaffId = staffId;
      this.deleteFormulaPopup.show = true;
    },
    closeAddFormulaPopup(){
      this.addFormulaPopup.show = false;
    },
    showAddFormulaPopup(staffId, staffName){
      this.addFormulaStaffName = staffName;
      this.addFormulaStaffId = staffId;
      this.addFormulaPopup.show = true;
    },
    returnUpdatedImgLink(link) {
      let now = new Date();
      return link + "?update=" + now.getTime();
    },
    getStatistic(){
      this.$store.dispatch("startPreloader");

      salaryRepository.calculate({
        date_from: this.periodDateFrom,
        date_to: this.periodDateTo
      }).then(resp => {
        this.statistics = resp.data;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.getFormulas();
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    addFormula(formula){
      let result = {};
      result.formula = formula.original_formula;
      result.variables = [];
      for(let key in formula.variables){
        let validate = validator.validate([
          {
            fieldName: formula.variables[key].variable_rus_name,
            value: formula.variables[key].variable_value,
            type: "required",
          },
          {
            fieldName: formula.variables[key].variable_rus_name,
            value: formula.variables[key].variable_value,
            type: "integer"
          }
        ]);
        if(validate.result == "error"){
          this.$store.dispatch("addNotification", {
            text: validate.message,
            time: 3,
            color: "danger"
          });
          return false;
        }
        result.variables[result.variables.length] = {
          'name': formula.variables[key].variable_original_name,
          'value': formula.variables[key].variable_value
        };
      }

      salaryRepository.setFormula({
        formula: result.formula,
        staff_id: this.addFormulaStaffId,
        variables: JSON.stringify(result.variables)
      }).then(resp => {
        if(resp.data.result === 'ok'){
          this.getStaff();
          this.closeAddFormulaPopup();
        }
      }).catch(err => {
        this.getFormulas();
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    getStaff(){
      salaryRepository.getStaff().then(resp => {
        this.requestCount++;
        this.staff = resp.data;
        this.getFormulas();
      }).catch(err => {
        this.getFormulas();
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    getFormulas(){
      salaryRepository.getFormulas().then(resp => {
        this.formulas = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    }
  },
  metaInfo: {
    title: "Расчет зарплат - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  created() {
    this.getStaff();
  }
};
</script>

<style scoped lang="less">
.calc-salary--container{
  width: 100%;
}
.calc-salary--staffs{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: row;

  .calc-salary--staff{
    width: 320px;
    margin-right: 8px;
    margin-top: 8px;

    .shadow-card{
      .calc-salary--flex{
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        flex-direction: row;

        .avatar{
          width: 30%;
          text-align: center;

          img{
            width: 95%;
          }
        }
        .info{
          width: 65%;
        }
      }
    }
  }
}
.formulas--item{
  .formula{
    font-size: 15px;
  }
  .descr{
    margin-top: 5px;
  }
}
.calc-salary--statistic{
  .date-interval{
    .row{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      flex-direction: row;

      &>div{
        margin-right: 5px;
      }
    }
  }
  .stat{
    .stat-container{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      flex-direction: row;

      .result{
        text-align: center;
        font-size: 18px;
      }

      .item{
        width: 300px;
        margin-right: 10px;
      }
    }
  }
}
@media (max-width: 750px) {
  .calc-salary--staffs {
    justify-content: center;
  }
}
</style>
